(function() {
  const initParallax = () => {
    const items = document.querySelectorAll('.js-parallax-item');
    if (items.length === 0) return;

    const updatePosition = () => {
      const scrolled = window.pageYOffset;

      items.forEach(item => {
        const speed = parseFloat(item.dataset.speed) || 0;
        // Vertikaler Versatz durch Scrollen
        const yOffset = scrolled * (speed * 0.15);
        item.style.transform = `translate3d(0, ${yOffset}px, 0)`;
      });
    };

    window.addEventListener('scroll', updatePosition, { passive: true });
    updatePosition();
  };

  if (document.readyState === 'complete') {
    initParallax();
  } else {
    window.addEventListener('DOMContentLoaded', initParallax);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initParallax();
  });
})();

